import React from 'react';
import ReactDOM from 'react-dom/client';
import '@ant-design/v5-patch-for-react-19';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';

// Suppress ResizeObserver loop error (common with Ant Design)
if (typeof window !== 'undefined') {
  const errorHandler = (e: ErrorEvent) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
      const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay');
      const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay-div');
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.style.display = 'none';
      }
      if (resizeObserverErr) {
        resizeObserverErr.style.display = 'none';
      }
      e.stopPropagation();
      e.stopImmediatePropagation();
      return true;
    }
  };
  window.addEventListener('error', errorHandler);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
